import { render, staticRenderFns } from "./FreteComprado.vue?vue&type=template&id=2e2dc75c&scoped=true"
import script from "./FreteComprado.vue?vue&type=script&lang=js"
export * from "./FreteComprado.vue?vue&type=script&lang=js"
import style0 from "./FreteComprado.vue?vue&type=style&index=0&id=2e2dc75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2dc75c",
  null
  
)

export default component.exports